import loadCustomerModule from './modules/Customer.module';
import loadSessionModule from './modules/Session.module';
const loadAccountEnrichmentModule = () => ({
    hasRouter: false,
    modules: [loadCustomerModule(), loadSessionModule()],
});
export default loadAccountEnrichmentModule;
